export default "__VITE_ASSET__CwVR6RqD__"